import { FeatureApiTags } from './FeatureApiTags';
import { portalApi } from '../../../../store/generated/portal/feature';
import featureSlice from '../../../../common/slices/featureSlice';

const taggedApi = portalApi.enhanceEndpoints({ addTagTypes: Object.values(FeatureApiTags) });

const featureApi = taggedApi.enhanceEndpoints({
  addTagTypes: [FeatureApiTags.FeatureFlags],
  endpoints: {
    apiPortalV1FeaturesPartialUpdate: {
      invalidatesTags: [FeatureApiTags.FeatureFlags],
    },
    apiPortalV1FeaturesUpdate: {
      invalidatesTags: [FeatureApiTags.FeatureFlags],
    },
    apiPortalV1FeaturesList: {
      providesTags: [FeatureApiTags.FeatureFlags],
      keepUnusedDataFor: Infinity, // Never purge from cache
      onCacheEntryAdded: async (arg, { dispatch, cacheDataLoaded, cacheEntryRemoved }) => {
        try {
          // Wait for the initial query to resolve
          const { data } = await cacheDataLoaded;

          // Dispatch the data to the feature slice
          if (data) {
            dispatch(featureSlice.actions.setFeatures(data));
          }

          // Wait for the cache entry to be removed
          await cacheEntryRemoved;
        } catch (error) {
          // Handle errors if needed
          console.error('Error in feature list cache entry:', error);
        }
      },
    },
  },
});

export { featureApi };
